export default class ItemIndexFinder {
  static findServiceIndex(serviceItems, updateItem) {
    return serviceItems.findIndex(service => {
      const payloadItem = service.item || service;
      const itemHasId = payloadItem.id;
      const idsMatch = payloadItem.id === updateItem.id;
      return itemHasId && idsMatch;
    });
  }

  static findTemporaryServiceIndex(serviceItems, updateItem) {
    return serviceItems.findIndex(service => {
      const payloadItem = service.item || service;
      return (
        updateItem.gmb_service_type &&
        payloadItem.gmb_service_type &&
        payloadItem.gmb_service_type.service_type_id ===
          updateItem.gmb_service_type.service_type_id
      );
    });
  }

  static getIndexes(serviceItems, updateItem) {
    const indexOfSelectedService = this.findServiceIndex(
      serviceItems,
      updateItem
    );
    const indexOfTemporaryService = this.findTemporaryServiceIndex(
      serviceItems,
      updateItem
    );

    return {
      indexOfSelectedService,
      indexOfTemporaryService
    };
  }

  static getUpdateServiceItemIndex(serviceItems, updatedItem) {
    const {
      indexOfSelectedService,
      indexOfTemporaryService
    } = ItemIndexFinder.getIndexes(serviceItems, updatedItem);

    if (indexOfSelectedService !== -1) {
      return indexOfSelectedService;
    } else if (indexOfTemporaryService !== -1) {
      return indexOfTemporaryService;
    }
    return -1;
  }

  static getPayloadItemIndex(serviceItems, updateItem) {
    return ItemIndexFinder.getIndexes(serviceItems, updateItem);
  }
}
